/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Error from './Error/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function AppAction({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content/Actions/Launchers/Content/App/AppAction",
  onSubmit,
  disabled
  
}) {
let launcherSubmitData = fromData.useDataSubmit({ viewPath,
context: 'launcher',
})
let launcherNameValueData = fromData.useDataValue({ viewPath,
context: 'launcher',
path: 'name',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 justifyContent="flex-start"
 width="100%"
 data="launcher"
 onClick={launcherSubmitData}
 disabled={disabled}
>
{childProps => (
<React.Fragment>
<Error
{...childProps}
  viewPath={`${viewPath}/Error`}
/>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="launcher.name"
 text={launcherNameValueData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}